import { Form } from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {MIcon, UniButton} from "../Elements";
import React from "react";
import {ResponseGetCompanies} from "./Api/response/companies";
import {ApiRoot} from "../RestFullApi/api";
import {CryptDecrypt} from "../Elements/crypt/Crypt";

const CompanySelect = (props:{value:any}) => {
    const navigate = useNavigate();

    const response = ResponseGetCompanies()

    const selectedCompany = response?.find((company) => company.selected === true);
    const preSelectedId = selectedCompany ? selectedCompany.id : "";

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedId = parseInt(e.target.value);

        if (!selectedId) return;

        const body = JSON.stringify({
            companyId: selectedId
        });

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization:
                    'Bearer ' +
                    JSON.parse(localStorage.getItem('token') as string)
            },
            body: body
        };

        fetch(ApiRoot() + 'yoptimize/company/switch/' + selectedId + "/", requestOptions)
            .then((response) => response.text())
            .then((result) => {
                console.log("Gespeichert:", result);
                window.location.reload();
            })
            .catch((error) => console.log(error));
    };

    if (
        process.env.REACT_APP_SOFTWARE_TYPE !== undefined &&
        process.env.REACT_APP_SOFTWARE_TYPE === 'yoptimize' &&
        response !== undefined && response !== null &&
        localStorage.getItem('userRights') !== null && localStorage.getItem('userRights') !== undefined && JSON.parse(CryptDecrypt(localStorage.getItem('userRights') as string) as string).isMandant === true
        ) {
        return (
            <div className={"col-3 d-flex float-end"}>
                <Form.Select
                    aria-label="Mandanten auswählen"
                    onChange={handleSelectChange}
                    value={preSelectedId}
                >
                    <option value="">Mandanten auswählen</option>
                    {response.map((company) => (
                        <option key={company.id} value={company.id}>
                            {company.name}
                        </option>
                    ))}
                </Form.Select>

                <UniButton onClick={() => navigate(`/company/new/0`)} class={"ms-2"}>
                    <MIcon children={"add"} className={"d-flex"} />
                </UniButton>
            </div>
        );
    } else {
        return <></>;
    }
};

export default CompanySelect;